/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AddQuestionDto } from '../models/AddQuestionDto';
import type { AddQuestionResponseDto } from '../models/AddQuestionResponseDto';
import type { CategoriesResponseDto } from '../models/CategoriesResponseDto';
import type { CreateTestDto } from '../models/CreateTestDto';
import type { NewFormResponseDto } from '../models/NewFormResponseDto';
import type { OkWithVersionResponseDto } from '../models/OkWithVersionResponseDto';
import type { TestResponseDto } from '../models/TestResponseDto';
import type { TestsListResponseDto } from '../models/TestsListResponseDto';
import type { TestWithQuestionsResponseDto } from '../models/TestWithQuestionsResponseDto';
import type { UpdateTestDto } from '../models/UpdateTestDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class TestsService {
    /**
     * @returns CategoriesResponseDto Список категорий тестов
     * @throws ApiError
     */
    public static testsControllerCategories(): CancelablePromise<CategoriesResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tests/categories',
        });
    }
    /**
     * @returns NewFormResponseDto Данные для формы создания теста
     * @throws ApiError
     */
    public static testsControllerNewForm(): CancelablePromise<NewFormResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tests/new',
        });
    }
    /**
     * @returns TestResponseDto Созданный тест
     * @throws ApiError
     */
    public static testsControllerCreate({
        requestBody,
    }: {
        requestBody: CreateTestDto,
    }): CancelablePromise<TestResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/tests/new',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns TestsListResponseDto Каталог тестов
     * @throws ApiError
     */
    public static testsControllerList({
        ownerType,
        categoryId,
        status,
        testScope,
        b2BOnly,
    }: {
        ownerType?: 'platform' | 'company',
        categoryId?: string,
        status?: 'draft' | 'published' | 'archived',
        testScope?: 'personal' | 'commercial',
        b2BOnly?: boolean,
    }): CancelablePromise<TestsListResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tests',
            query: {
                'ownerType': ownerType,
                'categoryId': categoryId,
                'status': status,
                'testScope': testScope,
                'b2bOnly': b2BOnly,
            },
        });
    }
    /**
     * @returns TestWithQuestionsResponseDto Карточка теста с вопросами
     * @throws ApiError
     */
    public static testsControllerOne({
        id,
    }: {
        id: string,
    }): CancelablePromise<TestWithQuestionsResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tests/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @returns TestResponseDto Обновлённый тест
     * @throws ApiError
     */
    public static testsControllerUpdate({
        id,
        requestBody,
    }: {
        id: string,
        requestBody: UpdateTestDto,
    }): CancelablePromise<TestResponseDto> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/tests/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns AddQuestionResponseDto Добавленный вопрос + новая версия теста
     * @throws ApiError
     */
    public static testsControllerAddQuestion({
        id,
        requestBody,
    }: {
        id: string,
        requestBody: AddQuestionDto,
    }): CancelablePromise<AddQuestionResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/tests/{id}/questions',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns OkWithVersionResponseDto Вопрос удалён + новая версия теста
     * @throws ApiError
     */
    public static testsControllerRemoveQuestion({
        id,
        qid,
    }: {
        id: string,
        qid: string,
    }): CancelablePromise<OkWithVersionResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/tests/{id}/questions/{qid}/remove',
            path: {
                'id': id,
                'qid': qid,
            },
        });
    }
    /**
     * @returns TestResponseDto Тест опубликован
     * @throws ApiError
     */
    public static testsControllerPublish({
        id,
    }: {
        id: string,
    }): CancelablePromise<TestResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/tests/{id}/publish',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @returns TestResponseDto Тест архивирован
     * @throws ApiError
     */
    public static testsControllerArchive({
        id,
    }: {
        id: string,
    }): CancelablePromise<TestResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/tests/{id}/archive',
            path: {
                'id': id,
            },
        });
    }
}
